/**
 * V2 Flexible Layout — Text Section Field Configuration
 *
 * Title-only configuration for FlexibleLayout Text sections.
 * Unlike the full V2CopyBlockSection (title + subtitle + detail),
 * FlexibleLayout Text sections show a single text element.
 *
 * Proxy paths (via FlexibleSectionContentAdapter):
 *   content.copy.title → section.textContent.title
 */

import type { FieldConfig } from '../types/editorFieldTypes';
import { createTextStyleFields, remapTextFieldsForV2 } from './atomicFields';

/**
 * Single title text element for FlexibleLayout Text sections.
 *
 * Path mapping through proxy adapter:
 *   path: 'content.copy.title'           → enable/disable check
 *   l10nPath: 'content.copy.title'       → translations read/write
 *   styleFields: 'content.copy.title.*'  → text appearance
 */
export const V2_FLEXIBLE_TITLE_CONFIG: FieldConfig = {
  path: 'content.copy.title',
  label: 'Title',
  placeholder: 'Enter text',
  type: 'templateText',
  guideKey: 'screenedit-flexible-sections-text-title',
  l10nPath: 'content.copy.title',
  defaultValue: '',
  disableBehavior: 'null',
  styleFields: remapTextFieldsForV2(createTextStyleFields('content.copy.title')),
  templateConfig: {
    kindPath: 'content.copy.title.kind',
    labelsPath: 'content.copy.title.templateParams.labels',
    linksPath: 'content.copy.title.templateParams.links',
    countdownsPath: 'content.copy.title.templateParams.countdowns',
  },
};
